import { PageMode } from "@features/builder/GraphBuilderPage"
import StartMode, { StartModeProps } from "@features/builder/MainContent/StartMode"
import EditMode, { EditModeProps } from "@features/builder/MainContent/EditMode"

type MainContentProps = {
  mode: PageMode
  startModeProps: StartModeProps
  editModeProps: EditModeProps
}

const MainContent = (props: MainContentProps) => {
  return (
    <>
      {props.mode === PageMode.Start && <StartMode {...props.startModeProps} />}
      {props.mode === PageMode.Edit && <EditMode {...props.editModeProps} />}
    </>
  )
}

export default MainContent
